<template>
  <d-row>
    <d-col lg="8" xl="9">
      <d-card class="card-small mb-4">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Importar Arquivo (.txt)</h6>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <div class="import-container">
              <d-row>
                <d-col cols="12" class="mb-3">
                  <drop-down :callback="onFileSelect" :has-error="error" />

                  <div
                    v-if="error"
                    class="invalid-feedback d-block text-right mt-2"
                  >
                    {{ errorMessage }}
                  </div>
                </d-col>
              </d-row>
            </div>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <!-- Sidebar Widgets -->
    <d-col lg="4" xl="3" sm="12">
      <d-card class="card-small mb-3">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Ações</h6>
        </d-card-header>

        <d-card-footer
          class="border-top d-flex flex-column flex-xl-row justify-content-around"
        >
          <router-link
            class="btn-secondary btn text-white col-xl-5"
            :to="{ name: 'admin-word-list-import', params: { page: 1 } }"
          >
            Cancelar
          </router-link>
          <d-button
            @click="importFile"
            type="button"
            class="btn-primary mb-3 mb-xl-0 col-xl-5"
          >
            Importar
          </d-button>
        </d-card-footer>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import DropDown from '_shared/DropDown.vue';
import WordService from '_services/rest/modules/word';
import WordForm from './WordForm.vue';
import { MODEL, _LOAD_MODEL_ } from './WordModel';

export default {
  name: 'Word-import-form',
  components: {
    WordForm,
    DropDown,
  },
  data() {
    return {
      printType: '',
      winPrint: null,
      fileRawContent: null,
      error: false,
      errorMessage: '',
    };
  },
  computed: {
    word() {
      const { word } = this.$store.state.word;
      if (word) {
        Events.$emit(_LOAD_MODEL_, word);
        return word;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    ...mapActions(['activeAlert']),
    save() {
      this.$refs.wordForm.save();
    },
    onFileSelect(file) {
      this.reset();
      if (!file) return;

      if (!file.name.toLowerCase().endsWith('.txt')) {
        this.setError('O formato do arquivo deve ser .txt');
        return;
      }

      this.fileRawContent = file;
    },
    setError(msg) {
      this.error = true;
      this.errorMessage = msg;
    },
    reset() {
      this.error = false;
      this.fileRawContent = null;
      this.errorMessage = '';
    },
    importFile() {
      if (!this.fileRawContent) return;

      WordService.importFile(this.fileRawContent)
        .then(response => {
          this.activeAlert({
            message: `${response.inserted} palavras inseridas de ${response.total}!`,
            theme: 'success',
          });

          this.$router.push({
            name: 'admin-word-list-import',
            params: { puzzleId: response.id },
          });

          this.reset();
        })
        .catch(error => {
          this.activeAlert({
            message: 'Erro ao importar arquivo.',
            theme: 'danger',
          });
          console.error(error);
        })
        .finally(() => {
          this.isImporting = false;
        });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.print-link {
  color: $primary;
  text-decoration: underline;
  cursor: pointer;
}

.import-container {
  ::v-deep .drop {
    position: relative;
    overflow: hidden;

    input#uploadmytextfile {
      height: 100% !important;
      top: 0 !important;
      position: absolute !important;
      z-index: 1 !important;
    }
  }
}
</style>

<style lang="scss">
@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
</style>
